import ArrowDown from './ArrowDown';
export default ArrowDown;

//# sourceMappingURL=index.js.map